import { defineStore } from 'pinia'

export const useResultsStore = defineStore({
    id: 'citation-search-results',
    state: () => ({
        Overview: {} as Server.ICitationSearchResultOverview,
        Assessments: [] as Array<Server.ICitationSearchResultAssessment>,
        Attachments: [] as Array<Server.ICitationSearchResultAttachment>,
    }),
    actions: {
        setResults(results: Server.ICitationSearchResult) {
            this.Overview = results.Overview;
            this.Assessments = results.Assessments.sort((a, b) => a.SortOrder - b.SortOrder);
            this.Attachments = results.Attachments;
        },

        clearResults() {
            this.Overview = {} as Server.ICitationSearchResultOverview;
            this.Assessments = [] as Array<Server.ICitationSearchResultAssessment>;
            this.Attachments = [] as Array<Server.ICitationSearchResultAttachment>;
        },

        setAmountUserWillPay(AmountToPay: number) {
            this.Overview.AmountToPay = AmountToPay;
        },
    },
    persist: true,
})
